import './style.scss';
import register from 'ShopUiBundle/modules/app/registry';

// tslint:disable-next-line
register('form-check', () => import(/* webpackMode: "lazy" */'./form-check'));
